<template>
  <div id="page-wrapper" v-if="loggedIn">
    <UserProfile />
    <div class="profile" v-if="user.upi_details">
      <div class="profile__row">
        <p class="profile__row__label">UPI ID:</p>
        <p class="profile__row__value">{{user.upi_details.vpa}}</p>
      </div>
    </div>

    <div class="profile-option">
      <router-link :to="{name: 'Transaction'}">
        <div class="section-header-card">
          <img
            src="/static/images/svgs/history-clock-button.svg"
            alt="Operator"
            class="section-header-card__image"
          />
          <div class="section-header-card__text">My Statements</div>
          <div class="section-header-card__stat">
            <img src="/static/images/svgs/arrow-next.svg" />
          </div>
        </div>
      </router-link>
      <router-link :to="{name: 'Bill Payments & Recharge History'}">
        <div class="section-header-card">
          <img
            src="/static/images/svgs/transaction-history.svg"
            alt="Operator"
            class="section-header-card__image"
          />
          <div class="section-header-card__text">Bill Payments & Recharge History</div>
          <div class="section-header-card__stat">
            <img src="/static/images/svgs/arrow-next.svg" />
          </div>
        </div>
      </router-link>
      <router-link to="/v2/transaction" v-if="user.features && user.features.referral.enabled">
        <div class="section-header-card">
          <img
            src="/static/images/svgs/favorite-heart-button.svg"
            alt="Operator"
            class="section-header-card__image"
          />
          <div class="section-header-card__text">Invite Friends</div>
          <div class="section-header-card__stat">
            <img src="/static/images/svgs/arrow-next.svg" />
          </div>
        </div>
      </router-link>
      <router-link to="/v2/reward-points">
        <div class="section-header-card">
          <img
            src="/static/images/svgs/medal-1.svg"
            alt="Operator"
            class="section-header-card__image"
          />
          <div class="section-header-card__text">Reward Points</div>
          <div class="section-header-card__stat">
            <img src="/static/images/svgs/arrow-next.svg" />
          </div>
        </div>
      </router-link>

      <a href="https://epaylater.in/help.html" target="_blank">
        <div class="section-header-card">
          <img
            src="/static/images/svgs/help-web-button.svg"
            alt="Operator"
            class="section-header-card__image"
          />
          <div class="section-header-card__text">Help and Support</div>
          <div class="section-header-card__stat">
            <img src="/static/images/svgs/arrow-next.svg" />
          </div>
        </div>
      </a>

      <div class="section-header-card card-logout" @click="logout">
        <img src="/static/images/svgs/logout.svg" alt="Operator" class="section-header-card__image" />
        <div class="section-header-card__text">
          <span class="section-header-card__text__span">Logout</span>
        </div>
      </div>

      <MobileNav :activeLink="'home'" class="visible-xs mt-50"></MobileNav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserProfile from "@/components/UserProfile/index";
import MobileNav from "../components/EplNewMobileNav/index";
export default {
  name: "profile",
  computed: {
    ...mapGetters(["loggedIn", "user"]),
  },
  components: { UserProfile, MobileNav },
  methods: {
    logout() {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "SCREEN",
        propertyName: "SCREEN_NAME",
        propertyValue: "LOGOUT",
      });
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.push({ name: "Login" });
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "PROFILE",
      propertyValue: "PROFILE",
    });
  },
};
</script>
<style lang="scss" scoped>
.profile {
  margin: 10px 0;
  color: #4d4d4d;
  &__row {
    display: flex;
    padding: 12px 27px;
    background: #fff;
    align-items: flex-start;
    &__label {
      font-size: 14px;
      font-weight: 300;
      margin-bottom: 0;
    }
    &__value {
      font-size: 16px;
      font-weight: 600;
      margin-left: 7px;
      margin-bottom: 0;
    }
  }
}

.profile-option {
  a {
    text-decoration: none;
  }
  .section-header-card {
    margin-bottom: 5px;
    cursor: pointer;
    &__text {
      &__span {
        cursor: pointer;
      }
      &__span:hover {
        cursor: pointer;
      }
      /*&__grey {
          color: #979797;
       }*/
    }
  }
}
.card-logout {
  background: none;
  cursor: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewProfile.vue